"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputBase.default;
  }
});

var _InputBase = _interopRequireDefault(require("./InputBase"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/InputBase/index.js
 ** module id = 140
 ** module chunks = 0
 **/